<template>
  <v-card>
    <v-card-title>
      {{ batch.name }}
      <v-spacer/>
      <v-btn
        small
        outlined
        rounded
        :to="{ name: 'BatchLabelView', params: { batchid: batch.id, id: batch.project }}"
      >
        <v-icon small left>print</v-icon>
        Label
      </v-btn>
    </v-card-title>
    <v-card-subtitle>
      <BatchNavigation :instance="batch"/>
    </v-card-subtitle>
    <v-card-text>
      <v-textarea
        :value="batch.runnotes"
        v-model="runnotes"
        auto-grow
        label="Run Notes"
        :disabled="disabled"
        filled
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn icon @click="disabled = !disabled" color="primary"><v-icon>edit</v-icon></v-btn>
      <v-btn icon :loading="loading" :disabled="disabled" @click="submit" color="success"><v-icon>save</v-icon></v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Batch from "../../models/Batch";
import BatchNavigation from "./BatchNavigation";
export default {
  name: "BatchNotesCard",
  components: {BatchNavigation},
  props: {
    batch: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      disabled: true,
      runnotes: this.batch.runnotes
    }
  },
  methods: {
    submit() {
      this.loading = true;
      this.disabled = true;
      Batch
        .$put(this.batch.id, { runnotes: this.runnotes })
        .then(() => this.loading = false )
    }
  }
}
</script>
